export const stats = [
  { id: 1, label: 'Verified Projects', value: 50, suffix: '+' },
  { id: 2, label: 'Trusted Advisors', value: 15, suffix: '+' },
  { id: 3, label: 'Client Satisfaction', value: 98, suffix: '%' },
  { id: 4, label: 'Happy Investors', value: 1200, suffix: '+' },
  { id: 5, label: 'Cities Covered', value: 8, suffix: '' },
  { id: 6, label: 'Years of Excellence', value: 7, suffix: '+' },
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Verified Opportunities',
    description: 'Every project is legally verified with complete documentation and NOC status confirmed before listing.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 2,
    title: 'Secure Documentation',
    description: 'We handle all legal paperwork, transfers, and documentation with precision and transparency.',
    icon: 'ri-file-shield-line',
  },
  {
    id: 3,
    title: 'Site Visit Support',
    description: 'Complimentary site visits with expert guidance to help you make informed investment decisions.',
    icon: 'ri-map-pin-line',
  },
  {
    id: 4,
    title: 'Transparent Consultation',
    description: 'Honest advice with no hidden fees. We disclose everything upfront so you invest with confidence.',
    icon: 'ri-hand-heart-line',
  },
  {
    id: 5,
    title: 'Investment Guidance',
    description: 'Personalized investment strategies based on your goals, budget, and timeline for maximum returns.',
    icon: 'ri-line-chart-line',
  },
  {
    id: 6,
    title: 'Prime Opportunities',
    description: 'Access to the best locations and projects before they become available to the general market.',
    icon: 'ri-star-line',
  },
];

export const services = [
  {
    id: 1,
    title: 'Property Buying',
    description: 'Find and secure the perfect residential or commercial property with expert guidance throughout the purchase process.',
    icon: 'ri-home-4-line',
  },
  {
    id: 2,
    title: 'Property Selling',
    description: 'Maximize your property value with strategic marketing, professional listing, and our extensive buyer network.',
    icon: 'ri-exchange-line',
  },
  {
    id: 3,
    title: 'Project Marketing',
    description: 'Comprehensive marketing solutions for real estate developers including branding, sales strategy, and lead generation.',
    icon: 'ri-megaphone-line',
  },
  {
    id: 4,
    title: 'Investment Consultation',
    description: 'Data-driven investment advice tailored to your financial goals with market analysis and ROI projections.',
    icon: 'ri-bar-chart-box-line',
  },
  {
    id: 5,
    title: 'Documentation Assistance',
    description: 'End-to-end documentation support including legal verification, transfer processing, and NOC applications.',
    icon: 'ri-stack-line',
  },
  {
    id: 6,
    title: 'Commercial Advisory',
    description: 'Strategic commercial property advice for offices, retail spaces, and industrial investments with location analysis.',
    icon: 'ri-building-4-line',
  },
  {
    id: 7,
    title: 'Booking Support',
    description: 'Seamless booking experience with flexible payment plans, installment options, and financing guidance.',
    icon: 'ri-calendar-check-line',
  },
  {
    id: 8,
    title: 'Site Visits',
    description: 'Personalized site tours with expert consultants who walk you through every aspect of the property or project.',
    icon: 'ri-car-line',
  },
];

export const howWeWorkSteps = [
  {
    id: 1,
    title: 'Consultation',
    description: 'We begin with understanding your investment goals, budget, and preferences through a personalized consultation.',
    icon: 'ri-chat-3-line',
  },
  {
    id: 2,
    title: 'Recommendation',
    description: 'Based on your profile, we recommend verified projects that align with your financial objectives and lifestyle.',
    icon: 'ri-lightbulb-line',
  },
  {
    id: 3,
    title: 'Site Visit',
    description: 'We arrange a complimentary site visit so you can experience the project firsthand and evaluate the location.',
    icon: 'ri-map-pin-user-line',
  },
  {
    id: 4,
    title: 'Documentation',
    description: 'Our legal team handles all paperwork, verification, and documentation with complete transparency.',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 5,
    title: 'Booking',
    description: 'Secure your property with a flexible payment plan that suits your financial situation and timeline.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 6,
    title: 'Investment Support',
    description: 'We continue to support you post-purchase with market updates, resale assistance, and portfolio management.',
    icon: 'ri-customer-service-2-line',
  },
];